import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import {makeStyles} from '@mui/styles'
import {Spacing, Colors, Typography} from '../../assets/styles'
import {borderRadiusMedium} from '../../assets/styles/border'
import LineGraph from '../Charts/LineGraph'
import DataComingSoon from '../DataComingSoon'

const TITLE = 'Exit NPS Score'
const GRAPH_HEIGHT = 300
const Y_AXIS_LABELS = ['-100', '-50', '0', '50', '100']
const PALETTE = [Colors.magenta]

/**
 * The asset's exit-survey NPS score over time — the same single-line LineGraph configuration Resident
 * Sentiment uses for its NPS Score section.
 * @param {Object} props
 * @param {?import('../../lib/MetricData/metricDataUtilities').ExitSurveyNPSTrend} props.trend
 */
function ExitSurveyNPSTrendChart({trend}) {
  const classes = useStyles()

  const columns = (trend && trend.columns) || []
  const data = (trend && trend.data) || []
  const hasData = columns.length > 0 && data.some(line => line.some(value => typeof value === 'number'))

  return (
    <div className={classes.section}>
      <div className={classes.title}>{TITLE}</div>

      {!hasData ? (
        <DataComingSoon />
      ) : (
        <div style={{height: GRAPH_HEIGHT}}>
          <LineGraph
            yAxisLabels={Y_AXIS_LABELS}
            data={data}
            xAxisLabels={columns}
            formatXAxis={s => moment(s).format('MMM YYYY')}
            yAxisMin={-100}
            yAxisMax={100}
            palette={PALETTE}
            onHover={d => d.yValue}
          />
        </div>
      )}
    </div>
  )
}

ExitSurveyNPSTrendChart.propTypes = {
  trend: PropTypes.shape({
    columns: PropTypes.arrayOf(PropTypes.string),
    data: PropTypes.arrayOf(PropTypes.array),
  }),
}

const useStyles = makeStyles({
  section: {
    marginTop: Spacing.spaceMedium,
    padding: Spacing.spaceMedium,
    backgroundColor: Colors.rxrWhiteColor,
    border: `1px solid ${Colors.rxrGreyColor}`,
    borderRadius: borderRadiusMedium,
    boxShadow: Colors.shadowSoft,
  },
  title: {
    marginBottom: Spacing.spaceMedium,
    fontSize: Typography.fontSizeLarge,
    fontWeight: Typography.heavyFontWeight,
    color: Colors.rxrBlackColor,
  },
})

export default ExitSurveyNPSTrendChart
